export class CONSTANT_MESSAGES {
  // Existing Activity Messages
  public static ADD_FACILITY_SUCCESS = 'Added a Activity successfully.';
  public static ADD_FACILITY_ERROR = 'An error occured while adding the Activity.';
  public static FORGOT_PASSWORD_ERROR = 'An error occured in forgot password.';
  public static ERROR_IN_FACILITY_START_TIME_AND_END_TIME = 'Activity start time should be less than end time. Please try again.';
  public static ERROR_IN_EVENT_START_TIME_AND_END_TIME = 'Event start time should be less than end time. Please try again.';
  public static ERROR_IN_FACILITY_TIME_DURATION = 'Activity start time should not be the same as end time. Please try again.';
  public static ERROR_IN_FACILITY_CLOSED_TIME_SLOT = 'Ensure Activity closure time is within Activity open timing.';
  public static ERROR_IN_FACILITY_CLOSED_START_TIME_AND_END_TIME = 'Ensure Activity closure start time should be less than end time.';
  public static ERROR_IN_FACILITY_CLOSED_TIME_DURATION = 'Ensure Activity closure start and end times should not be same.';
  public static ERROR_IN_FACILITY_PEAK_TIME_SLOT = 'Ensure Activity peak time is within Activity open timings.';
  public static ERROR_IN_FACILITY_PEAK_START_TIME_AND_END_TIME = 'Ensure Activity peak start time should be less than end time.';
  public static ERROR_IN_FACILITY_PEAK_TIME_DURATION = 'Ensure Activity peak start and end times not the same.';
  public static ERROR_IN_FACILITY_PEAK_TIME_AND_CLOSED_TIME = 'Ensure Activity peak time and closure time should not overlap.';
  public static REQUIRE_EMAIL_ID = 'Please enter email id.';
  public static REQUIRE_CONTACT_NUMBER = 'Please enter Contact Number.';
  public static REQUIRE_MEMBERSHIP_ID = 'Please enter Membership Id.';
  public static REQUIRE_VALID_EMAIL_ID = 'Please enter a valid Email Id.';
  public static REQUIRE_VENDOR = 'Vendor is required.';
  public static REQUIRE_MEMBER_OBJECT = 'Member object is null.';
  public static DELETE_CONFIRMATION = 'Are you sure you want to delete this Activity?';
  public static EDIT_CONFIRMATION = 'Your data will be lost. Do you want to continue?';
  public static LOGOUT_CONFIRMATION = 'Are you sure you want to Logout?';
  public static ERROR_IN_BOOKING_UNIT = 'Booking slot should not greater than open hours';
  public static REDIRECT_FROM_ACTIVITY = 'Your data will be loss, do you want to continue';
  public static MESSAGE_NO_ACTIVITY_ADDED = 'Currently, there are no Activities added. Please add an Activity.';
  public static MESSAGE_MARK_AS_VISITED = 'Are you sure you want to mark bookings as visited?';

  // **NEW EVENT-SPECIFIC CONSTANTS**
  // Event CRUD Messages
  public static ADD_EVENT_SUCCESS = 'Event added successfully.';
  public static ADD_EVENT_ERROR = 'An error occurred while adding the Event.';
  public static UPDATE_EVENT_SUCCESS = 'Event updated successfully.';
  public static UPDATE_EVENT_ERROR = 'An error occurred while updating the Event.';
  public static DELETE_EVENT_CONFIRMATION = 'Are you sure you want to delete this Event?';
  public static DELETE_EVENT_SUCCESS = 'Event deleted successfully.';
  public static DELETE_EVENT_ERROR = 'An error occurred while deleting the Event.';


  // Event Validation Messages
  public static EVENT_NAME_REQUIRED = 'Event name is required.';
  public static EVENT_TYPE_REQUIRED = 'Event type is required.';
  public static EVENT_DATE_REQUIRED = 'Event date is required.';
  public static EVENT_DATE_PAST_ERROR = 'Event date cannot be in the past.';
  public static EVENT_DATE_FUTURE_ERROR = 'Event date cannot be more than 2 years in the future.';
  public static EVENT_TIMINGS_REQUIRED = 'Event start time and end time are required.';
  public static EVENT_START_TIME_END_TIME_ERROR = 'Event start time should be less than end time.';
  public static TIMINGS_REQUIRED = 'Start and end times are required.';
  public static CLOSE_TIME_GREATER = 'End time must be after start time.';
  public static EVENT_ICON_REQUIRED = 'Please select an icon for the event.';
  public static EVENT_ADDRESS_REQUIRED = 'Event address is required.';
  public static EVENT_PINCODE_REQUIRED = 'Pincode/Postal Code is required.';
  public static EVENT_COUNTRY_REQUIRED = 'Country is required.';
  public static EVENT_CAPACITY_REQUIRED = 'Event capacity is required.';
  public static EVENT_DATE_UPDATE_RESTRICTED_DURING_BOOKING = 'Updating the event date is not allowed during booking.';

  public static GST_INVALID = 'GST must be between 0 and 100';
  public static GST_DECIMALS = 'GST can have at most 2 decimals';
  public static NO_OF_SLOTS_REQUIRED = 'Please enter number of slots';
  public static NO_OF_SLOTS_INVALID = 'Number of slots must be at least 1';

  // Event Status Messages
  public static EVENT_COMPLETED_READ_ONLY = 'This event has been completed and is now in read-only mode.';
  public static EVENT_PAST_NO_EDIT = 'Past events cannot be edited or deleted.';
  public static EVENT_INVALID_DATE_TIME = 'Event has invalid date/time information.';


  // Event Dashboard Messages
  public static MESSAGE_NO_EVENTS_ADDED = 'No events have been created yet. Click "Add Event" to create your first event.';
  public static MESSAGE_NO_BOOKINGS_ADDED = 'No Bookings have been created yet. Click "Add Group Bookings" to create your first Group Booking.';
  public static NO_UPCOMING_EVENTS = 'No upcoming events scheduled.';
  public static NO_PAST_EVENTS = 'No past events found.';
  public static CREATE_FIRST_EVENT = 'Create your first event to get started!';
  public static PAST_EVENTS_INFO = 'Past events will appear here once they are completed.';


  // Event Form Messages
  public static EVENT_FORM_DATA_LOSS_WARNING = 'Your event data will be lost. Do you want to continue?';
  public static INVALID_VENDOR_ERROR = 'Invalid vendor information. Please reload the page.';
  public static EVENT_SAVE_CONFIRMATION = 'Are you sure you want to save this event?';


  // Event File Upload Messages
  public static INVALID_FILE_TYPE = 'Please select a valid image file (JPG, PNG, BMP, TIFF).';
  public static FILE_SIZE_EXCEEDED = 'File size must be less than 5MB.';


  // Modal Titles
  public static DELETE_CONFIRMATION_TITLE = 'Delete Confirmation';
  public static EDIT_CONFIRMATION_TITLE = 'Edit Confirmation';
  public static EVENT_ERROR_TITLE = 'Event Error';
  public static EVENT_SUCCESS_TITLE = 'Success';


  // Event Navigation
  public static BACK_TO_EVENTS_DASHBOARD = 'Back to Events Dashboard';


  // BOOKINGENTRY
  public static CANCEL_BOOKING = 'Are you sure, you want to cancel this booking ?';
  public static MAKE_PAYMENT = 'Are you sure you want to confirm the booking and received payment, if necessary?';
  public static DATA_MATCH = 'Data mismatch.';


  // HTML string
  public static PEOPLE = 'People';
  public static WAITLIST = 'Waitlist';


  // Calendar
  public static PAYMENT_RECIEVED_CONFIRMATION = 'Are you sure, you want to mark this booking as payment received?';
  public static SLOT_NO_AVAILABLE_ERROR_MSG = 'Sorry. The bookings are not open for this slot.';
  public static SUPER_ADMIN_NO_BOOKING_ERROR_MSG = 'Sorry, Super Admin is not allowed to make booking';
  public static CANNOT_BOOK_THIS_SLOT_ERROR_MSG = 'You cannot do booking for this slot';


  // HTML Strings
  public static VIEW_SUMMARY_BUTTON_TEXT = 'VIEW SUMMARY';
  public static CALENDAR_TITLE = 'Calendar';
  public static FILTER_BY_ALL = 'All';
  public static FILTER_BY_CONFIRMED = 'Confirmed';
  public static AVAILABLE = 'Available';
  public static WAITLISTED = 'Waitlisted';
  public static UNAVAILABLE = 'Unavailable';
  public static PEAKTIME = 'Peaktime';
  public static CLOSED = 'Closed';
  public static BLOCKED = 'Blocked';
  public static PAYMENT_PENDING = 'Payment Pending';
  public static HOUSE_RULES = 'House Rules';
  public static MAXIMUM_BOOKING_HOURS = 'Maximum Booking Hours Per Month';
  public static MAXIMUM_BOOKING_EACH_DAY_DURING_PEAK_TIME = 'Maximum booking each day during peak time';
  public static ACTIVITY_CHARGES = 'Activity Charges';
  public static PEAK_TIME = 'Peak Time';
  public static WAIT_LIST_COUNT = 'Wait list Count';


  // FEEDBACK
  public static MESSAGE_NO_FEEDBACK_ADDED = 'Currently, there are no feedback added.';


  // Group
  public static DEACTIVATE_GROUP = 'Do you want to deactivate the group?';
  public static ACTIVATE_GROUP = 'Do you want to activate the group?';
  public static NO_MEMBER_ADDED = 'Currently, there are no members in this group. Please add members';
  public static NO_RECORD_FOUND = 'No records found.';
  public static REMOVE_MEMBERS = 'please select member to remove from group';
  public static CONFIRMATION_REMOVE_MEMBER = 'Are you sure to remove member from group';
  public static ADD_MEMBER = 'Please select member to add in group';
  public static CONFIRMATION_ADD_MEMBER = 'Are you sure to add member in group';
  public static NO_GROUP = 'Currently, there are no groups added. Please add a group.';
  public static CONFIRMATION_DELETE_GROUP_PART1 = 'Are you sure to delete';
  public static CONFIRMATION_DELETE_GROUP_PART2 = 'group ?';
  public static CONFIRMATION_CREATE_GROUP = 'Are you sure, you want create group';


  // CREATE NO_GROUP
  public static ADD_MEMBER_GROUP = 'Add Members in group';
  public static GENDER_LIST = ['Male', 'Female', 'Other'];
  public static FILTER_MEMBER = ['Group', 'Preferences', 'Inactive', 'Disable For Activity', 'Payment Pending'];
  public static ATTENDEES_MEMBER_AT_BOOKING = 1;


  // Deactivate members
  public static DEACTIVATE_MEMBERS = 'It will be deactivate untill not activate.';
  public static DATE_CONFIRMATION = 'End date should be greater than start date.';


  // Booking calendar
  public static DAY_BOOKING_ERROR = 'Please ensure that the booking is made for a day!';
  public static NUMPER_OF_PEOPLE_ERROR = 'Please enter valid number of people';


  // Feeds
  public static SELECT_MEMBER_FEED = 'Please select members for broadcast';
  public static SELECT_Group_FEED = 'Please select groups for broadcast';
  public static IMAGE_ERROR = 'Please select a valid image format (.jpg, .png, .bmp, .jpeg, .tiff)';
  public static ERROR_MESSAGE_SUBJECT = 'Please fill Subject';
  public static ERROR_MESSAGE_CONTENT = 'Please fill Content';
  public static SELECT_ACTIVITY_FOR_ALERT = 'Please select activity';
  public static SELECT_RECIPIENTS_BROADCAST = 'Please fill Recipients';
  public static NO_FEED_ADDED_MESSAGE = 'Currently, there are no feeds added.';
  public static NO_MEMBER_AVAILABLE = 'There is no member available';
  public static NO_GROUP_AVAILABLE = 'There is no group available';
  public static INVALID_URL = 'Enter proper url and there should only one url';


  // Member detail
  public static DELETE_MEMBER = 'Are you sure you want to delete this member?';
  public static RESEND_CODE_MEMBER = 'Are you sure you want to resend the code?';
  public static DEACTIVATE_MEMBER = 'Are you sure you want to deactivate this member?';
  public static ACTIVATE_MEMBER = 'Are you sure you want to activate this member?';
  public static DESABLE_MEMBER = 'Please select the members that you want to disable.';
  public static ENABLE_MEMBER = 'Please select the members that you want to enable.';
  public static DEATCIVATE_MULTIPLE_MEMBER = 'Are you sure you want to deactivate these members?';
  public static SELECT_DEATCIVATE_MEMBER = 'Please select the members that you want to deactivate.';


  // Member
  public static NO_MEMBER_ADDED_MESSAGE = 'Currently, there are no members added. Please add a member.';
  public static FILE_NOT_SUPPORT = 'File not supported.';
  public static MEMBERSHIP_ID_VALIDATION = 'Membership Id can accept combination of Numbers, Alphabets and these special characters ( such as -, _ and /)';


  // INACTIVATE MEMBER
  public static SELECT_MEMBER_TO_ACTIVATE = 'Select members to activate.';


  // Upload member on-boarding
  public static INVALID_FILE_COLUMNS = 'Please verify the columns in the file you have uploaded.';
  public static SKIP_WIZARD = 'Are you sure you want to skip the wizard process';
  public static FINISH_WIZARD = 'Wizard process completed succesfully. You will now be taken to the all members screen.';
  public static REMARK_MEMBER = 'Member added successfully.';
  public static SERVICE_ERROR_INVITE_MEMBER = 'Something Went Wrong. Service returned error';
  public static UNKNOWN_ERROR = 'Something Went Wrong. Unknown Error';

  // Summary - view
  public static START_DATE_LESS_ERROR_MESSAGE = 'Start Date should be less than or equal to end date';


  // HTML String
  public static SUMMARY_VIEW_TITLE = 'Summary View';
  public static FILTER_TITLE = 'Filter By Booking Status';
  public static APPLY_FILTER_BUTTON_TEXT = 'Apply Filter';
  public static VIEW_ALL_BLOCKED_SLOT_BUTTON_TEXT = 'VIEW ALL BLOCKED SLOTS';
  public static NEW_BOOKING_BUTTON_TEXT = 'NEW BOOKING';
  public static SUMMARY_VIEW_PRINT_TITLE = 'Booking Summary Report';
  public static LABEL_ACTIVITY_NAME = 'Activity Name';
  public static LABEL_UNIT_NAME = 'Unit Name';
  public static TEXT_SELECT = 'Select';
  public static LABEL_START_DATE = 'Start Date';
  public static LABEL_END_DATE = 'End Date';
  public static LABEL_EVENT_DATE = 'Event Date';
  public static APPLY_BUTTON_TEXT = 'Apply';
  public static BOOKINGS_TITLE = 'Bookings';
  public static PRINT_BUTTON_TEXT = 'PRINT';
  public static BLOCK_SLOTS_BUTTON_TEXT = 'BLOCK SLOTS';
  public static NO_BOOKINGS_AVAILABLE_ERROR_MSG = 'No bookings available for this slot';
  public static PRINT_MEMB_ID = 'Member Id';
  public static LABEL_TIME = 'Time';
  public static LABEL_FULLNAME = 'Full Name';
  public static LABEL_MOBILENUM = 'Mobile Number';
  public static LABEL_CHECK_IN = 'Check in';
  public static LABEL_CHECK_OUT = 'Check out';
  public static LABEL_CHECK_IN_OUT = 'Check In - Check Out';
  public static ACTION_BUTTON_TEXT = 'Action';
  public static SEARCH = 'Search';
  public static UPLOAD_BLOCK_SLOTS = 'Upload block slots'


  // Walk-in Booking popup
  public static BOOK_BUTTON_TEXT = 'BOOK';
  public static FORCEBOOK_BUTTON_TEXT = 'FORCE BOOK';
  public static CONTINUE_BUTTON_TEXT = 'CONTINUE';
  public static MAX_NO_OF_PEOPLE_ERROR = 'Max No of people cannot exceed ';
  public static BOOKING_WITHIN_ACTIVITY_TIMINGS_ERROR = 'Booking should be within activity timings';
  public static BOOKING_OPEN_TILL_NEXT_MONTH = 'Bookings allowed till';
  public static BOOKING_OPEN_TILL_NEXT_MONTH_CONT = 'as per house rules';


  // HTML string
  public static ADD_MEMBER_TITLE = 'Do you want to add this member to the system?';
  public static ADD_SYSTEM_MEMBER_TITLE = 'Add this person as a member in the system and group.';
  public static ADD_MEMBER_YES = 'Yes';
  public static SELECT_NAME = 'Select Name';
  public static SELECT_COUNTRY_CODE = 'Select Country Code';
  public static NO_OF_SLOTS = 'No. of Slots';
  public static BOOKING_DATE = 'Booking Date';
  public static START_TIME = 'Start Time';
  public static END_TIME = 'End Time';
  public static MEMB_ID = 'Membership Id';
  public static FIRST_NAME = 'First Name';
  public static LAST_NAME = 'Last Name';
  public static CONTACT_NUMBER = 'Contact Number';
  public static EMAIL_ID = 'Email Id';
  public static HOURS = 'Hours';
  public static MINUTES = 'Minutes';
  public static NO_OF_PEOPLE = 'No. of People';
  public static SELECT_TYPE = 'Select Type';
  public static FORCE_BOOKING_MSG = 'Do you want to force book these slots?';
  public static CANCEL_BUTTON_TEXT = 'CANCEL';
  public static NO_OF_TIMES_BUTTON_TEXT = 'No. of Times';


  // Block Dates
  public static START_DATE_LESS_ERROR_MSG = 'start date should be less than end date';
  public static START_TIME_LESS_ERROR_MSG = 'start time should be less than end time';
  public static WITHIN_ACTIVITY_TIMINGS_ERROR_MSG = 'Please select within the activity timings';
  public static ATLEAST_ONE_SLOT = 'At least add one block slot';
  public static SLOT_ERROR_1 = 'The slot ';
  public static TEXT_FOR = ' for ';
  public static SLOT_ERROR_2 = ' is already blocked. Please fill proper data.';
  public static SLOT_ERROR_3 = ' is already present';


  // HTML strings
  public static BLOCK_BUTTON_TEXT = 'BLOCK';
  public static LABEL_ACTIVITY = 'Activity';
  public static BOOKING_END_DATE = 'Booking End Date';
  public static DATA_LABEL_ENTIRE_DAY = 'Entire Day';
  public static SELECT_ACTIVITY = 'Select Activity';
  public static ACTIVITY = 'Activity';
  public static BLOCK_SLOTS_TITLE = 'Block Slots';
  public static ADD_NEW_BUTTON_TEXT = 'ADD NEW';


  // UnBlock
  public static NO_BLOCKED_SLOTS_ERROR_MSG = 'There are no blocked slots';
  public static ATLEAST_ONE_BLOCK_SLOT = 'Select at least one slot';
  public static CALENDAR_DATE_LESS_ERROR_MSG = 'Calendar start date should be less than end date';
  public static DATE_NOT_VALID = 'Date is not valid';
  public static UNBLOCK_CONFIRMATION = 'Are you sure you want to unblock selected slots';
  public static ATLEAST_ONE_SLOT_UNLOCK = 'Please select at least one slot to unblock';


  // HTML strings
  public static BLOCKED_SLOTS_TITLE = 'BLOCKED SLOTS';
  public static BLOCK_NEW_SLOTS = 'BLOCK NEW SLOTS';
  public static UNBLOCK_BUTTON_TEXT = 'UNBLOCK';


  // Guest Booking
  public static ENTER_VALID_NO_OF_PEOPLE_ERROR_MSG = 'Enter Valid no of people';
  public static SELECT_START_TIME_ERROR_MSG = 'Please select start time';


  // HTML Strings
  public static GUEST_BOOKING_NOTE_MSG = 'An alert will be sent to the user once the changes are saved.';
  public static NOT_AVAILABLE = 'Not available';


  // Add member
  // HTML string
  public static MEMBERS_TITLE = 'Members';
  public static SAVE_BUTTON_TEXT = 'SAVE';
  public static ADDRESS_LABEL = 'Address';


  // Member List
  // HTML String
  public static MEMBER_LIST_TITLE = 'All Members';
  public static MEMBER_STAFF_TITLE = 'All Staffs';
  public static FILTER_BY = 'Filter By';
  public static INACTIVE = 'Inactive';
  public static DISABLE_FOR_ACTIVITY = 'Disable for Activity';
  public static PREFERENCES = 'Preferences';
  public static GROUPS = 'Groups';
  public static CREATE_GROUP = 'CREATE GROUP';
  public static ADD_MEMBER_BUTTON_TEXT = 'ADD MEMBER';
  public static ON_BOARDING_BUTTON_TEXT = 'ON BOARDING';
  public static DOWNLOAD_TEMPLATES = 'DOWNLOAD TEMPLATES';
  public static UPLOAD = 'UPLOAD';
  public static UPLOAD_BOOKING = 'UPLOAD BOOKINGS';
  public static UPLOAD_MEMBERS = 'UPLOAD MEMBER';


  // Inactive Member
  public static IN_ACTIVE_MEMBER_TITLE = 'Inactive Members';
  public static DEACTIVATE_NEW_MEMBERS = 'DEACTIVATE NEW MEMBERS';
  public static ACTIVATE_MEMBERS = 'ACTIVATE MEMBERS';
  public static ACTIVATE = 'ACTIVATE';
  public static DEACTIVATE = 'DEACTIVATE';


  // Disable member
  public static DISABLE_MEMBER_TITLE = 'Disable Members';
  public static DISABLE_NEW_MEMBERS = 'DISABLE NEW MEMBERS';
  public static ENABLE_MEMBERS = 'ENABLE MEMBERS';
  public static ENABLE_BUTTON_TEXT = 'ENABLE';
  public static DISABLE_BUTTON_TEXT = 'DISABLE';


  // Member details
  public static MEMBER_DETAILS = 'Member Details';
  public static ADDRESS = 'Address';
  public static GROUP = 'Group';
  public static RESEND_CODE = 'RESEND CODE';
  public static SAVE = 'SAVE';
  public static EDIT = 'EDIT';
  public static DELETE = 'DELETE';


  // Enable members popup
  public static ENABLE_MEMBERS_TITLE = 'Enable Members';
  public static ENABLE_MEMBER_CONFIRMATION = 'Do you want to enable members for below Activity?';
  public static OK_BUTTON_TEXT = 'OK';


  // Disable member popup
  public static DISABLE_MEMBERS_TITLE = 'Disable Members';
  public static DISABLE_MEMBER_CONFIRMATION = 'Do you want to disable members for below Activity?';
  public static REASON = 'Reason';


  // Side menu
  public static MEMBERS = 'Members';
  public static ALL_MEMBERS = 'All Members';
  public static INACTIVE_MEMBERS = 'Inactive Members';
  public static DISABLE_MEMBERS = 'Disable Members';
  public static ALL_GROUP = 'All Group';
  public static ACTIVITIES = 'Activities';
  public static ALL_ACTIVITIES = 'All Activities';
  public static EVENTS = 'Events'; // NEW
  public static LINKS = 'Links'; // NEW
  public static GROUP_BOOKINGS = 'Group Bookings'; // NEW
  public static ALL_EVENTS = 'All Events'; // NEW
  public static BOOKING_CALENDAR = 'Booking Calendar';
  public static STAFF = 'Staff';
  public static FEED = 'Feed';
  public static FEEDBACK = 'Feedback';
  public static ANALYTICS = 'Analytics';
  public static MANAGE_PROFILE = 'Manage Profile';
  public static LOGOUT = 'Logout';
  public static PRIVACY_POLICY = 'Privacy Policy';
  public static SUPPORT = 'Support';
  public static COPYRIGHTS = '2024 Copyright by FRIDAY.LIFE. All rights reserved.';
  public static VERSION = 'Version';


  // Deactivate popup
  public static SELECT_GROUP = 'Select Group';


  // Information popup
  public static NOTES = 'Notes';
  public static BY_MEMBER = 'By member';
  public static BY_VENDOR = 'By Vendor';


  // Member Table
  public static MEMBER_PER_PAGE = 'Members Per Page';
  public static ACTIVE_INACTIVE = 'Active/Inactive';
  public static JOINED_DATE = 'Joined Date';
  public static FAVORITES = 'Favorites';
  public static TYPES_OF_MEMBERS = 'Type of Members';
  public static PER_PAGE = 'Per Page';


  // Change password
  public static PASSWORD_NOT_MATCHING = '* Password is not matching';
  public static ATLEAST_ONE_CHARACTER = '* Use at least 1 character';


  // HTML string
  public static CHANGE_PASSWORD_TITLE = 'Change Password';
  public static CHANGE_PASSWORD_LABEL = 'Enter the required information in the input fields below.';
  public static OLD_PASSWORD = 'Old Password';
  public static NEW_PASSWORD = 'New Password';
  public static RETYPE_PASSWORD = 'Retype New Password';


  // Forget Password
  public static RESET_PASSWORD_TITLE = 'Reset Password?';
  public static SEND_BUTTON_TEXT = 'SEND';


  // Sign In
  public static LOGIN_TITLE = 'LOGIN';
  public static USER_ID = 'User Id';
  public static PASSWORD = 'Password';
  public static REMEMBER_ME = 'Remember Me';


  // Create Group
  public static LINK_ACTIVITY_TITLE = 'Link Activity';
  public static EDIT_LINK_ACTIVITY_TITLE = 'Edit Activity Linking';
  public static LINK_ACTIVITY_HEADER = 'Select activities from the following list to link activities with Group';
  public static SELECT_ACTIVITIES = 'Select Activities';
  public static NO_FACILITIES_ERROR_MSG = 'There are no activities to select';
  public static GROUP_NAME_EMPTY_ERROR_MSG = 'Enter group name';
  public static SELECT_MEMBERS = 'SELECT MEMBERS';
  public static CREATE_BUTTON_TEXT = 'CREATE';


  // Feed
  public static FEED_TITLE = 'Feed';
  public static FEED_COMPOSE_MESSAGE = 'COMPOSE MESSAGE';
  public static FEED_HISTORY = 'FEED HISTORY';
  public static FEED_BROADCAST = 'BROADCAST';
  public static FEED_SEND_TO = 'Sent To';
  public static FEED_SEARCH = 'Search';
  public static FEED_CATEGORY = 'BROADCAST';
  public static FEED_TOPNAV = 56;
  public static FEED_MIDNAV = 45;
  public static FOOTER = 35;
  public static CONTAINER = 40;
  public static FEED_SEND_TO_ALL_MEMBER = 'All Members';
  public static FEED_SEND_TO_SPECIFIC_MEMBER = 'Specific Members';
  public static FEED_SEND_TO_ALL_GROUP = 'All Groups';
  public static FEED_SEND_TO_SPECIFIC_GROUPS = 'Specific Groups';


  // Scroll Options
  public static BAR_BACKGROUND = '#343a40';
  public static PU_BAR_OPACITY: '0.6';
  public static POSITION: 'right';
  public static BARWIDTH: '6';
  public static BAR_BORDER_RADIUS: '5';
  public static BAR_MARGIN: '1px 1px';
  public static GRID_BACKGROUND: '#adb5bd';
  public static GRID_OPACITY: '1';
  public static GRID_WIDTH: '4';
  public static GRID_BORDER_RADIUS: '10';
  public static GRID_MARGIN: '1px 2px';

  // Common
  public static SEARCH_PLACEHOLDER = 'Search';
  public static OK = 'OK';
  public static SEND_INVITE = 'SEND INVITE';
  public static TYPE = 'Type';
  public static SEND_INVITE_FILTER = 'Send Invite';
  public static CONTINUE = 'Continue';

  // Booking popup
  public static MEMB_ID_OR_FIRSTNAME = 'Enter membership id or first name';

  // Loyalty
  public static LOYALTY_LIST_TITLE = 'Loyalty summary view';
  public static LOYALTY_DETAIL_TITLE = 'Member level spend view';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/constants/constants-messages.ts